var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupTopLineImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1560,
    height: 694,
    viewBox: "0 0 1560 694",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00003 339.562C61.8691 179.147 167.286 111.964 519.131 225.763C549.25 225.763 1317.29 516.43 1150.26 190.115",
    stroke: "url(#paint0_linear_389_26)",
    strokeOpacity: 0.13,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_389_26",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1235,
    y: 0,
    width: 652,
    height: 694
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1235,
    y: 465.816,
    width: 571,
    height: 394,
    transform: "rotate(-54.6656 1235 465.816)",
    fill: "#2E2E2E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_389_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1626.42 654.279L1446.76 265.973L1872.64 306.963L1626.42 654.279Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 56.8844
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_26",
    x1: 1174.4,
    y1: 274.939,
    x2: 2.65496,
    y2: 290.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#211E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8176AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTopLineImg);
export default __webpack_public_path__ + "static/media/groupTopLineImg.8957258eb6b2ca8b0ad84fed586105a7.svg";
export { ForwardRef as ReactComponent };